<template>
    <div>
        <Header title="成员管理">
            <template v-slot:content>
                <div style="display: flex">
                    <div style="flex:1">
                    </div>
                    <div>
                        <Button @click="async_d">同步</Button>
                        <Button style="margin-left:20px" @click="add_member" type="primary" >创建</Button>
                    </div>

                </div>
            </template>
        </Header>
        <div class="my-white-mod">
            <PageTable :loading="table.loading" :size="table.limit" :columns="table.columns" :data="table.data" :current="table.current" :total="table.total" @switchPage="changepage" >
            </PageTable>
        </div>

        <Modal
                :mask-closable="false"
                v-model="show_edit"
                title="编辑"
                width="400"
        >
            <div class="modal-title">名称</div>
            <Input  placeholder="请填写名称" v-model="submitForm.name" />
            <div class="modal-title modal-title-two">花名</div>
            <Input  placeholder="请填写花名" v-model="submitForm.alias" />
            <div class="modal-title modal-title-two">手机号</div>
            <Input  placeholder="请填写手机号" v-model="submitForm.mobile" />
            <div class="modal-title modal-title-two">密码</div>
            <Input  type="password" placeholder="请填写登录密码" v-model="submitForm.pwd" />
            <div class="modal-title modal-title-two">邮箱</div>
            <Input  placeholder="请填写邮箱" v-model="submitForm.email" />
            <div class="modal-title modal-title-two">性别</div>
            <Select  placeholder="请选择性别" v-model="submitForm.gender" >
                <Option v-for="item in genderArr" :value="item.id" :key="item.id">{{ item.name }}</Option>
            </Select>
            <div slot="footer">
                <Button  type="primary"  @click="ok_edit">确定</Button >
            </div>
        </Modal>
    </div>

</template>
<script>
    import {department_member_list, department_member_manager, department_member_del} from "@/api/system"

    import {sync_department_member} from "@/api/sync"
    import {Header, PageTable} from "@/components/mainLayout"
    export default {
        components:{
            Header,
            PageTable
        },
        data(){
            return{
                genderArr:[
                    {id:1, name:'男'},
                    {id:2, name:'女'}
                ],
                show_edit:false,
                submitForm:{
                    "id":"",
                    "name":"",
                    "alias":"",
                    "mobile":"",
                    "email":"",
                    "gender":"",
                    "pwd":""
                },
                table:{
                    current:1,
                    total:0,
                    loading:false,
                    columns: [
                        {
                            align:'center',
                            type: 'index'
                        },
                        {
                            title: '成员名称',
                            align:'center',
                            key: 'name',
                            width:200
                        },
                        {
                            title: '花名',
                            align:'center',
                            key: 'alias',
                            width:200
                        },
                        {
                            title: '所属部门',
                            align:'center',
                            key: 'departmentId_name'
                        },
                        {
                            title: '职务信息',
                            align:'center',
                            key: 'position'
                        },
                        {
                            title: '手机号',
                            align:'center',
                            key: 'mobile',
                            width:130
                        },
                        {
                            title: '邮箱',
                            align:'center',
                            key: 'email',
                            width:150
                        },
                        {
                            title: '性别',
                            align:'center',
                            key: 'gender',
                            render:(h, params)=>{
                                return h('div', [
                                    h('span', {
                                        style:{color:params.row.gender == 1? '#445E87' :'#ff0000'}
                                    }, params.row.gender == 1? '男' :'女')
                                ]);
                            }
                        },
                        {
                            title: '创建时间',
                            align:'center',
                            width:200,
                            key: 'ctime'
                        },
                        {
                            title: '操作',
                            align:'center',
                            key: 'id',
                            render: (h, params) => {
                                let btr = [
                                    h('Button', {
                                        props: {
                                            type: 'text',
                                            size: 'small'
                                        },
                                        style:{color:'#3F8CFF'},
                                        on: {
                                            click: () => {
                                                this.edit_show(params.row)
                                            }
                                        }
                                    }, '编辑')
                                ]
                                if (params.row.company == 0) {
                                    btr.push(
                                        h('Button', {
                                            props: {
                                                type: 'text',
                                                size: 'small'
                                            },
                                            style:{color:'#ff0000'},
                                            on: {
                                                click: () => {
                                                    this.delete_show(params.row)
                                                }
                                            }
                                        }, '删除')
                                    )
                                }
                                return h('div', btr);

                            }
                        }
                    ],
                    data: []
                }

            }
        },
        mounted(){
            this.getList()
        },
        methods:{

            getList(){
                this.table.loading = true
                department_member_list({limit:this.table.limit, page:this.table.current, pid:1}).then(res=>{
                    this.table.loading = false
                    if (res.code == 200) {
                        this.table.data = res.data
                        this.table.total = res.total
                    } else {
                        this.table.data = []
                        this.table.total = 0
                        this.$Message.error(res.msg)
                    }

                })
            },
            changepage(e){
                this.table.current = e;
                this.getList();
            },
            async_d(){
                this.$Notice.info({
                    title: '员工数据同步中',
                });
                sync_department_member().then(res=>{
                    this.$Notice.destroy()
                    if (res.code == 200) {
                        this.getList();
                        this.$Message.success(res.msg);
                    } else {
                        this.$Message.error(res.msg);
                    }
                })
            },
            edit_show(e){
                this.submitForm.id = e.id
                this.submitForm.name = e.name
                this.submitForm.alias = e.alias
                this.submitForm.mobile = e.mobile
                this.submitForm.gender = e.gender
                this.submitForm.email = e.email
                this.show_edit = true
            },
            ok_edit(){
                if (this.submitForm.name == "") {
                    this.$Message.error("名称不能为空");return
                }
                if (this.submitForm.mobile == "") {
                    this.$Message.error("手机号不能为空");return
                }
                if (this.submitForm.id == "" && this.submitForm.pwd == "") {
                    this.$Message.error("密码不能为空");return
                }
                department_member_manager(this.submitForm).then(res=>{
                    if (res.code == 200) {
                        this.show_edit = false
                        this.getList();
                        this.$Message.success(res.msg);
                    } else {
                        this.$Message.error(res.msg);
                    }
                })
            },
            add_member(){
                this.submitForm = {
                    "id":"",
                    "name":"",
                    "alias":"",
                    "mobile":"",
                    "email":"",
                    "gender":"",
                    "pwd":""
                }
                this.show_edit = true
            },
            delete_show(e){
                this.$Modal.confirm({
                    title: '提示',
                    content: '<p>是否删除该用户？</p>',
                    onOk: () => {
                        department_member_del({id:e.id}).then(res=>{
                            if (res.code == 200) {
                                this.getList()
                                this.$Message.success(res.msg);
                            } else {
                                this.$Message.error(res.msg)
                            }
                        })
                    }
                });
            }
        }
    }
</script>
